<template>
  <div>
    <el-dialog :show-close="false" fullscreen :visible.sync="dialogVisible" :before-close="handleClose" append-to-body
      :title="$t('lbl_patient')" custom-class="cs-modal">
      <template slot="title">
        <div>
          <h2 class="text-3xl font-bold text-start m-0 px-4 text-black">{{ $t("lbl_patient") }}</h2>
          <el-divider class="mt-2 mb-0" />
        </div>
      </template>
      <div v-loading="isLoading">
        <div v-if="isConfirm" class="relative flex justify-between fs-18 mb-3 p-3" style="background-color: #ffefd9">
          <div class="flex gap-4">
            <div class="flex items-center">
              <WarningIcon />
            </div>
            <div class="fs-20 break-words" style="word-break: break-word" v-html="$t(
              'lbl_patient_abc_does_not_yet_exist_on_hodo_s_electronic_medical_record_system__please_click_save_to_store_patient_information_',
              { name: form.name }
            )
              " />
          </div>
        </div>
        <div class="flex flex-col md:flex-row items-center justify-between gap-2">
          <h2 class="text-2xl font-bold text-start text-blue-900 mb-0">{{ title }}</h2>
          <div class="flex gap-2 items-center justify-between">
            <button @click="handleClose" :disabled="isLoading"
              class="fs-14 flex items-center justify-center border-0 focus:outline-none bg-indigo-50 text-gray-600 rounded-lg h-10 px-3 py-2 ml-auto w-15">
              <div>{{ $t("lbl_cancel") }}</div>
            </button>

            <button v-if="false" :disabled="isLoading || true"
              class="fs-14 flex items-center gap-1 justify-center border-0 focus:outline-none bg-indigo-50 text-blue-900 rounded-lg h-10 px-3 py-2 ml-auto w-28 cursor-not-allowed">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.0003 1.66675C7.86398 1.67284 5.81157 2.49918 4.26699 3.97508V2.50008C4.26699 2.27907 4.1792 2.06711 4.02291 1.91083C3.86663 1.75455 3.65467 1.66675 3.43366 1.66675C3.21265 1.66675 3.00068 1.75455 2.8444 1.91083C2.68812 2.06711 2.60033 2.27907 2.60033 2.50008V6.25008C2.60033 6.4711 2.68812 6.68306 2.8444 6.83934C3.00068 6.99562 3.21265 7.08342 3.43366 7.08342H7.18366C7.40467 7.08342 7.61663 6.99562 7.77291 6.83934C7.92919 6.68306 8.01699 6.4711 8.01699 6.25008C8.01699 6.02907 7.92919 5.81711 7.77291 5.66083C7.61663 5.50455 7.40467 5.41675 7.18366 5.41675H5.18366C6.25514 4.29705 7.68325 3.58563 9.22244 3.40481C10.7616 3.22398 12.3157 3.58506 13.6175 4.42595C14.9193 5.26684 15.8875 6.53501 16.3556 8.01241C16.8237 9.48981 16.7624 11.0841 16.1823 12.5212C15.6023 13.9584 14.5396 15.1485 13.1771 15.887C11.8146 16.6255 10.2374 16.8663 8.71662 16.5679C7.19585 16.2695 5.82655 15.4505 4.84415 14.2519C3.86176 13.0533 3.32765 11.5498 3.33366 10.0001C3.33366 9.77907 3.24586 9.56711 3.08958 9.41083C2.9333 9.25455 2.72134 9.16675 2.50033 9.16675C2.27931 9.16675 2.06735 9.25455 1.91107 9.41083C1.75479 9.56711 1.66699 9.77907 1.66699 10.0001C1.66699 11.6483 2.15573 13.2594 3.07141 14.6298C3.98709 16.0002 5.28858 17.0683 6.8113 17.6991C8.33401 18.3298 10.0096 18.4948 11.6261 18.1733C13.2426 17.8517 14.7274 17.0581 15.8929 15.8926C17.0583 14.7272 17.852 13.2423 18.1735 11.6258C18.4951 10.0093 18.3301 8.33377 17.6993 6.81105C17.0686 5.28834 16.0005 3.98685 14.6301 3.07117C13.2597 2.15549 11.6485 1.66675 10.0003 1.66675ZM10.0003 6.66675C9.77931 6.66675 9.56735 6.75455 9.41107 6.91083C9.25479 7.06711 9.16699 7.27907 9.16699 7.50008V10.0001C9.16699 10.2211 9.25479 10.4331 9.41107 10.5893C9.56735 10.7456 9.77931 10.8334 10.0003 10.8334H11.667C11.888 10.8334 12.1 10.7456 12.2562 10.5893C12.4125 10.4331 12.5003 10.2211 12.5003 10.0001C12.5003 9.77907 12.4125 9.56711 12.2562 9.41083C12.1 9.25455 11.888 9.16675 11.667 9.16675H10.8337V7.50008C10.8337 7.27907 10.7459 7.06711 10.5896 6.91083C10.4333 6.75455 10.2213 6.66675 10.0003 6.66675Z"
                  fill="currentColor" />
              </svg>

              <div>{{ $t("Lịch sử") }}</div>
            </button>
            <button @click="submit" :disabled="isLoading"
              class="fs-14 flex items-center justify-center border-0 focus:outline-none bg-blue-900 text-white rounded-lg h-10 px-3 py-2 ml-auto w-15">
              <div>{{ $t("lbl_save") }}</div>
            </button>
          </div>
        </div>
        <div class="overflow-y-scroll mt-6 cs-content">
          <div class="bg-white p-6 mb-6 hodo-el">
            <h4 class="text-black font-bold text-lg mb-4">{{ $t("lbl_administrative_information") }}</h4>
            <div class="flex gap-3 flex-col">
              <div class="row">
                <div class="col-md-3 mb-2">
                  <div class="fs-14 text-gray-600 font-semibold required">
                    {{ $t("lbl_full_name") }}
                    <!-- <span class="text-red-500">*</span> -->
                  </div>
                  <el-input class="cs-uppercase" type="text" v-model="form.name" />
                </div>

                <div class="col-md-3 mb-2">
                  <div class="fs-14 text-gray-600 font-semibold">
                    {{ $t("lbl_identifier") }}
                    <!-- <span class="text-red-500">*</span> -->
                  </div>

                  <el-input @blur="(e) => {
                    const params = {
                      value: e.target.value,
                      key: 'cmnd',
                    };
                    handleCheckExist(params);
                  }
                    " type="text" v-model="form.cmnd" />
                </div>
                <div class="col-md-3 mb-2">
                  <div class="fs-14 text-gray-600 font-semibold">{{ $t("lbl_patient_code") }}</div>
                  <el-input @blur="(e) => {
                    const params = {
                      value: e.target.value,
                      key: 'pid',
                    };
                    handleCheckExist(params);
                  }
                    " v-model="form.pid" />
                </div>
                <div class="col-md-3 mb-2">
                  <div class="fs-14 text-gray-600 font-semibold required">
                    {{ $t("lbl_phone_number") }}
                    <!-- <span class="text-red-500">*</span> -->
                  </div>

                  <el-input @blur="(e) => {
                    const params = {
                      value: e.target.value,
                      key: 'phone',
                    };
                    handleCheckExist(params);
                  }
                    " type="number" v-model="form.phone" />
                </div>

                <!-- <div class="col-md-3 mb-2">
                <div class="fs-14 text-gray-600 font-semibold">Mã Điều trị</div>
                <el-input
                  @blur="(e)=>{
                    const params={
                      value:e.target.value,
                      key:'so_ho_so'
                    }
                    handleCheckExist(params)
                  }"
                  v-model="form.doc_no"
                />
                </div>-->
              </div>
              <div class="row">
                <div class="col-md-3 mb-2">
                  <div class="fs-14 text-gray-600 font-semibold required">
                    {{ $t("lbl_sex") }}
                    <!-- <span class="text-red-500">*</span> -->
                  </div>
                  <div class="mt-2">
                    <el-radio-group class="cs-radio" v-model="form.gender">
                      <el-radio :label="1">{{ $t("lbl_male") }}</el-radio>
                      <el-radio :label="2">{{ $t("lbl_female") }}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="col-md-3 mb-2">
                  <div class="fs-14 text-gray-600 font-semibold required">
                    {{ $t("lbl_date_of_birth") }}
                    <span class="text-red-500">*</span>
                  </div>
                  <el-input type="date" v-model="form.birthday" />
                </div>
                <div class="col-md-3 mb-2">
                  <div class="fs-14 text-gray-600 font-semibold">{{ $t("lbl_job") }}</div>
                  <el-input type="text" v-model="form.career" />
                </div>
                <div class="col-md-3 mb-2">
                  <div class="fs-14 text-gray-600 font-semibold">{{ $t("lbl_day_of_admission") }}</div>
                  <el-input type="datetime-local" v-model="form.admission_hospital_date" />
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 mb-2">
                  <div class="fs-14 text-gray-600 font-semibold">{{ $t("lbl_province_city") }}</div>
                  <el-select class="select-cs" filterable allow-create v-model="form.address_province_name"
                    :placeholder="$t('lbl_select_province_city')" @change="handleSelectProvince">
                    <el-option v-for="item in provinces" :key="item.province_id" :label="item.name"
                      :value="item.name"></el-option>
                  </el-select>
                  <!-- <el-input  type="text" v-model="form.address_province_name" /> -->
                </div>
                <div class="col-md-3 mb-2">
                  <div class="fs-14 text-gray-600 font-semibold">{{ $t("lbl_district") }}</div>
                  <el-select class="select-cs" filterable allow-create v-model="form.address_district_name"
                    :placeholder="$t('lbl_select_district')" @focus="handleGetDistricts" @change="handleSelectDistrict">
                    <el-option v-for="item in districts" :key="item.district_id" :label="item.name"
                      :value="item.name"></el-option>
                  </el-select>
                  <!-- <el-input  type="text" v-model="form.address_district_name" /> -->
                </div>
                <div class="col-md-3 mb-2">
                  <div class="fs-14 text-gray-600 font-semibold">{{ $t("lbl_commune") }}</div>
                  <el-select class="select-cs" filterable allow-create v-model="form.address_wards_name"
                    :placeholder="$t('lbl_select_commune')" @focus="handleGetWards">
                    <el-option v-for="item in wards" :key="item.ward_id" :name="item.name"
                      :value="item.name"></el-option>
                  </el-select>
                  <!-- <el-input  type="text" v-model="form.address_wards_name" /> -->
                </div>
                <div class="col-md-3 mb-2">
                  <div class="fs-14 text-gray-600 font-semibold">{{ $t("lbl_address") }}</div>
                  <el-input type="text" v-model="form.address" />
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 mb-2">
                  <div class="fs-14 text-gray-600 font-semibold">{{ $t("lbl_nationality") }}</div>
                  <el-input type="text" v-model="form.nationality_name" />
                </div>
                <div class="col-md-3 mb-2">
                  <div class="fs-14 text-gray-600 font-semibold">{{ $t("lbl_workplace") }}</div>
                  <el-input type="text" v-model="form.work_at" />
                </div>
                <div class="col-md-3 mb-2">
                  <div class="fs-14 text-gray-600 font-semibold">{{ $t("lbl_nation") }}</div>
                  <el-input type="text" v-model="form.ethnic_name" />
                </div>
                <div class="col-md-3 mb-2">
                  <div class="fs-14 text-gray-600 font-semibold">{{ $t("lbl_foreigners") }}</div>
                  <el-input type="text" v-model="form.foreigner" />
                </div>
              </div>

              <div class="row">
                <div class="col-md-3 mb-2">
                  <div class="fs-14 text-gray-600 font-semibold">{{ $t("lbl_relatives") }}</div>
                  <el-input type="text" v-model="form.emergency_contact" />
                </div>
                <div class="col-md-3 mb-2">
                  <div class="fs-14 text-gray-600 font-semibold">{{ $t("lbl_family_phone_number") }}</div>
                  <el-input type="text" v-model="form.contact_phone" />
                </div>
              </div>
            </div>
          </div>
          <div class="bg-white p-6 hodo-el">
            <h4 class="text-black font-bold text-lg mb-3">{{ $t("lbl_social_healthcare_insurance") }}</h4>
            <div class="row flex items-center">
              <div class="col-md-2 mb-2">
                <div class="fs-14 text-gray-600 font-semibold">{{ $t("lbl_subjects_of_social_healthcare_insurance") }}
                </div>
                <el-select class="select-cs" v-model="form.insurance_type" :placeholder="$t('lbl_select')">
                  <el-option v-for="item in options" :key="item.value" :label="$t(`${item.label}`)"
                    :value="item.value"></el-option>
                </el-select>
              </div>
              <div class="col-md-4 mb-2">
                <div class="fs-14 text-gray-600 font-semibold">{{ $t("lbl_social_healthcare_insurance_number") }}</div>
                <el-input :disabled="!isSelectedBHYT" type="text" v-model="form.insurance_number" />
              </div>
              <div class="col-md-2 mb-2">
                <div class="fs-14 text-gray-600 font-semibold">{{ $t("lbl_start_date") }}</div>
                <el-input :disabled="!isSelectedBHYT" type="date" v-model="form.insurance_start_date" />
              </div>
              <div class="col-md-2 mb-2">
                <div class="fs-14 text-gray-600 font-semibold">{{ $t("lbl_expried_date") }}</div>
                <el-input :disabled="!isSelectedBHYT" type="date" v-model="form.insurance_expire" />
              </div>
              <div class="col-md-2 mb-2">
                <div class="fs-14 text-gray-600 font-semibold">{{ $t("lbl_benefit_level") }} (%)</div>
                <el-input :disabled="!isSelectedBHYT" type="number" v-model="form.insurance_rate" />
              </div>
            </div>

            <button @click="handleAddInsurance" :disabled="isLoading" v-if="!form.insurances || !form.insurances.length"
              class="fs-14 flex items-center justify-center border-0 focus:outline-none bg-blue-900 text-white rounded-lg h-10 px-3 py-2 w-15">
              <div>
                <svg width="22" height="22" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M28 16C28 16.2652 27.8946 16.5196 27.7071 16.7071C27.5196 16.8946 27.2652 17 27 17H17V27C17 27.2652 16.8946 27.5196 16.7071 27.7071C16.5196 27.8946 16.2652 28 16 28C15.7348 28 15.4804 27.8946 15.2929 27.7071C15.1054 27.5196 15 27.2652 15 27V17H5C4.73478 17 4.48043 16.8946 4.29289 16.7071C4.10536 16.5196 4 16.2652 4 16C4 15.7348 4.10536 15.4804 4.29289 15.2929C4.48043 15.1054 4.73478 15 5 15H15V5C15 4.73478 15.1054 4.48043 15.2929 4.29289C15.4804 4.10536 15.7348 4 16 4C16.2652 4 16.5196 4.10536 16.7071 4.29289C16.8946 4.48043 17 4.73478 17 5V15H27C27.2652 15 27.5196 15.1054 27.7071 15.2929C27.8946 15.4804 28 15.7348 28 16Z"
                    fill="white" />
                </svg>
                {{ $t("Thêm loại Bảo hiểm") }}
              </div>
            </button>
            <div v-show="form.insurances && form.insurances.length" class="mt-2" ref="InsuranceList" id="InsuranceList">
              <div v-for="(insurance, index) in form.insurances" :key="index" class="row flex items-center mt-1">
                <div class="col-md-2 mb-2">
                  <div class="fs-14 text-gray-600 font-semibold">{{ $t("Tên loại Bảo hiểm") }}</div>
                  <el-input type="text" v-model="insurance.name" />
                </div>
                <div class="col-md-4 mb-2">
                  <div class="fs-14 text-gray-600 font-semibold">{{ $t("Số Bảo hiểm") }}</div>
                  <el-input type="text" v-model="insurance.policy_number" />
                </div>
                <div class="col-md-2 mb-2">
                  <div class="fs-14 text-gray-600 font-semibold">{{ $t("lbl_start_date") }}</div>
                  <el-input type="date" v-model="insurance.start_date" />
                </div>
                <div class="col-md-2 mb-2">
                  <div class="fs-14 text-gray-600 font-semibold">{{ $t("lbl_expried_date") }}</div>
                  <el-input type="date" v-model="insurance.end_date" />
                </div>
                <div class="col-md-2 mb-2">
                  <div class="fs-14 text-gray-600 font-semibold invisible">{{ $t("Hành động") }}</div>

                  <div class="flex gap-2 justify-start">
                    <div v-if="index === form.insurances.length - 1" @click="handleAddInsurance" class="cs-button-add">
                      <el-tooltip class="item" effect="dark" :content="$t('Thêm loại Bảo hiểm')" placement="top">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11 13V22H13V13H22V11H13V2L11 2V11H2V13H11Z" fill="#20409B" />
                        </svg>
                      </el-tooltip>
                    </div>
                    <div @click="handleRemoveVideo(index)" class="cs-button-delete">
                      <el-tooltip class="item" effect="dark" :content="$t('Xoá loại Bảo hiểm')" placement="top">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M10 18C10.2652 18 10.5196 17.8946 10.7071 17.7071C10.8946 17.5196 11 17.2652 11 17V11C11 10.7348 10.8946 10.4804 10.7071 10.2929C10.5196 10.1054 10.2652 10 10 10C9.73478 10 9.48043 10.1054 9.29289 10.2929C9.10536 10.4804 9 10.7348 9 11V17C9 17.2652 9.10536 17.5196 9.29289 17.7071C9.48043 17.8946 9.73478 18 10 18ZM20 6H16V5C16 4.20435 15.6839 3.44129 15.1213 2.87868C14.5587 2.31607 13.7956 2 13 2H11C10.2044 2 9.44129 2.31607 8.87868 2.87868C8.31607 3.44129 8 4.20435 8 5V6H4C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7C3 7.26522 3.10536 7.51957 3.29289 7.70711C3.48043 7.89464 3.73478 8 4 8H5V19C5 19.7956 5.31607 20.5587 5.87868 21.1213C6.44129 21.6839 7.20435 22 8 22H16C16.7956 22 17.5587 21.6839 18.1213 21.1213C18.6839 20.5587 19 19.7956 19 19V8H20C20.2652 8 20.5196 7.89464 20.7071 7.70711C20.8946 7.51957 21 7.26522 21 7C21 6.73478 20.8946 6.48043 20.7071 6.29289C20.5196 6.10536 20.2652 6 20 6ZM10 5C10 4.73478 10.1054 4.48043 10.2929 4.29289C10.4804 4.10536 10.7348 4 11 4H13C13.2652 4 13.5196 4.10536 13.7071 4.29289C13.8946 4.48043 14 4.73478 14 5V6H10V5ZM17 19C17 19.2652 16.8946 19.5196 16.7071 19.7071C16.5196 19.8946 16.2652 20 16 20H8C7.73478 20 7.48043 19.8946 7.29289 19.7071C7.10536 19.5196 7 19.2652 7 19V8H17V19ZM14 18C14.2652 18 14.5196 17.8946 14.7071 17.7071C14.8946 17.5196 15 17.2652 15 17V11C15 10.7348 14.8946 10.4804 14.7071 10.2929C14.5196 10.1054 14.2652 10 14 10C13.7348 10 13.4804 10.1054 13.2929 10.2929C13.1054 10.4804 13 10.7348 13 11V17C13 17.2652 13.1054 17.5196 13.2929 17.7071C13.4804 17.8946 13.7348 18 14 18Z"
                            fill="#EA5455" />
                        </svg>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <ModalSamePerson ref="ModalSamePerson" @onClose="() => {
      isShowSamePersonModal = false;
    }
      " @reUsePerson="reUsePerson" />
  </div>
</template>

<script>
import { WarningIcon } from '@/components/Icon'
import { ADDRESS_TYPE } from '@/utils/constants'
import { mixinHasFeatures } from '@/utils/mixinHasFeatures'
import ModalSamePerson from '../Person/ModalSamePerson.vue'

export default {
  name: 'ModalPatientInfoBreastExpert',
  components: { ModalSamePerson, WarningIcon },
  mixins: [mixinHasFeatures],
  props: {},
  data () {
    const defaultForm = {
      name: '',
      national_id: '',
      phone: null,
      birthday: '2000-01-01',
      gender: 2,
      career: '',
      foreigner: '',
      address: '',
      address_district_name: '',
      address_province_name: '',
      address_wards_name: '',
      work_at: '',
      insurance_type: '',
      insurance_expire: '',
      insurance_start_date: '',
      emergency_contact: '',
      contact_phone: '',
      pid: '',
      admission_hospital_date: '',
      ethnic_name: '',
      insurance_number: '',
      nationality_name: '',
      insurance_rate: '',
      isShowSamePersonModal: false,
      cmnd: '',
      insurances: [],
      generated_name: ''
    }
    const DEFAULT_EXIST = [
      {
        key: 'phone',
        isExist: false
      },
      {
        key: 'cmnd',
        isExist: false
      },
      {
        key: 'pid',
        isExist: false
      },
      {
        key: 'so_ho_so',
        isExist: false
      }
    ]
    return {
      title: this.$t('lbl_add_patient'),
      dialogVisible: false,
      isLoading: false,
      form: { ...defaultForm },
      defaultForm,
      arrExist: [],
      options: [
        {
          value: '1',
          label: 'lbl_social_healthcare_insurance_short'
        },
        {
          value: '2',
          label: 'lbl_fee'
        },
        {
          value: '3',
          label: 'lbl_exemptions'
        },
        {
          value: '4',
          label: 'lbl_other'
        }
      ],
      provinces: [],
      districts: [],
      wards: [],
      selectedAddress: {},
      isRequestSamePerson: false,
      DEFAULT_EXIST,
      isConfirm: false,
      patientInfo: {}
    }
  },
  computed: {
    isSelectedBHYT () {
      return this.form.insurance_type === this.options[0].value
    },
    isExist () {
      return this.arrExist?.some(item => item.isExist)
    }
  },
  created () { },
  methods: {
    async generateName () {
      await this.$rf
        .getRequest('DoctorRequest')
        .generateName({ ws_id: this.$globalClinic.id })
        .then(resp => {
          this.generated_name = resp.data?.name
          this.form.name = this.generated_name
        })
    },
    openDialog (
      isShow = true,
      modalTitle = this.$t('lbl_add_patient'),
      data = { ...this.defaultForm },
      isConfirm = false
    ) {
      if (isShow) {
        this.handleGetProvinces()
      }
      const formatData = {
        ...data,
        insurances:
          data.insurances?.map(item => ({
            ...item,
            start_date: window.moment(item.start_date).format('YYYY-MM-DD'),
            end_date: window.moment(item.end_date).format('YYYY-MM-DD')
          })) || []
      }

      this.dialogVisible = isShow
      this.title = modalTitle
      this.form = { ...formatData }
      this.patientInfo = { ...formatData }
      this.isRequestSamePerson = true
      this.isConfirm = isConfirm
      if (!this.patientInfo.name) this.generateName()
    },
    reUsePerson (selectedPerson) {
      this.isRequestSamePerson = false
      this.arrExist = [...this.DEFAULT_EXIST]
      this.form = {
        ...selectedPerson,
        insurance_expire: selectedPerson?.id
          ? selectedPerson.insurance_expire
          : window
            .moment(selectedPerson.insurance_expire, 'DD/MM/YYYY')
            .format('YYYY-MM-DD'),
        insurance_start_date: selectedPerson.insurance_start_date
          ? selectedPerson?.id
            ? selectedPerson.insurance_start_date
            : window
              .moment(selectedPerson.insurance_start_date, 'DD/MM/YYYY')
              .format('YYYY-MM-DD')
          : '',
        birthday: window.moment(selectedPerson.birthday).format('YYYY-MM-DD'),
        admission_hospital_date: selectedPerson.admission_hospital_date
          ? window
            .moment(selectedPerson.admission_hospital_date)
            .format('YYYY-MM-DD HH:mm:ss')
          : '',
        phone:
          typeof selectedPerson.phone === 'string'
            ? selectedPerson.phone.replaceAll('.', '').toString()
            : selectedPerson.phone,
        emergency_contact:
          typeof selectedPerson.emergency_contact === 'string'
            ? selectedPerson.emergency_contact.replaceAll('.', '').toString()
            : selectedPerson.emergency_contact,
        insurances:
          selectedPerson.insurances?.map(item => ({
            ...item,
            start_date: window.moment(item.start_date).format('YYYY-MM-DD'),
            end_date: window.moment(item.end_date).format('YYYY-MM-DD')
          })) || []
      }
    },
    async blurEventHandlerCCCD (e) {
      const cccd = e.target.value
      if (cccd && this.isRequestSamePerson) {
        const params = {
          cmnd: cccd
        }
        await this.$rf
          .getRequest('DoctorRequest')
          .checkExistPatient(params)
          .then(resp => {
            if (resp) {
              if (resp.data.data.length > 0) {
                this.$refs.ModalSamePerson.openDialog(resp.data.data)
              }
            }
          })
          .catch(e => {
            console.log(e)
          })
          .finally(() => { })
      }
    },
    async blurEventHandlerPhone (e) {
      const phone = e.target.value
      if (phone && this.isRequestSamePerson) {
        const params = {
          phone: phone
        }
        await this.$rf
          .getRequest('DoctorRequest')
          .checkExistPatient(params)
          .then(resp => {
            if (resp) {
              if (resp.data.data.length > 0) {
                this.$refs.ModalSamePerson.openDialog(resp.data.data)
              }
            }
          })
          .catch(e => {
            console.log(e)
          })
          .finally(() => { })
      }
    },
    async handleCheckExist (params) {
      const newParams = {
        ...params,
        page_num: 1,
        page_size: 1000
      }
      if (!newParams.value || this.isShowSamePersonModal || this.isConfirm) {
        return
      }
      try {
        const response = await this.$rf
          .getRequest('DoctorRequest')
          .checkExistPatient(newParams)
        if (response.data?.data?.length) {
          this.$refs.ModalSamePerson.openDialog(response.data.data)
          this.isShowSamePersonModal = true
          this.arrExist = this.arrExist.map(item => {
            if (item?.key === newParams.key) {
              return {
                key: item?.key,
                isExist: true
              }
            } else {
              return item
            }
          })
        } else {
          this.arrExist = this.arrExist.map(item => {
            if (item?.key === newParams.key) {
              return {
                key: item?.key,
                isExist: false
              }
            } else {
              return item
            }
          })
        }
      } catch (error) {
        console.log(error)
        this.arrExist = this.arrExist.map(item => {
          if (item?.key === newParams.key) {
            return {
              key: item?.key,
              isExist: false
            }
          } else {
            return item
          }
        })
      }
    },
    submit () {
      const self = this
      // if (!Number(self.form.phone)) {
      //   self.$message({
      //     message: self.$t('lbl_phone_number_invalid'),
      //     type: 'error'
      //   })
      //   return
      // }

      if (
        !self.form.name ||
        // !self.form.cmnd ||
        !self.form.birthday ||
        !self.form.gender
        // !self.form.phone
      ) {
        self.$message({
          message: self.$t('lbl_enter_data_breast_expert'),
          type: 'error'
        })
        return
      }

      if (self.form.birthday) {
        const _birthday = window.moment(self.form.birthday)
        if (
          String(_birthday.year()).length > 4 ||
          _birthday.year() > window.moment().year() ||
          isNaN(_birthday.year())
        ) {
          self.$message({
            message: self.$t('lbl_year_born_invalid'),
            type: 'error'
          })
          return
        }
        if (_birthday - window.moment() > 0) {
          self.$message({
            message: self.$t('lbl_date_of_birth_invalid'),
            type: 'error'
          })
          return
        }
      }

      if (self.form.insurances?.length) {
        const isInvalid = self.form.insurances?.some(item => {
          if (
            window
              .moment(item.start_date)
              .startOf('days')
              .valueOf() >=
            window
              .moment(item.end_date)
              .endOf('days')
              .valueOf()
          ) {
            return true
          } else {
            return false
          }
        })

        if (isInvalid) {
          self.$message({
            message: self.$t(
              'Ngày bắt đầu của bảo hiểm phải trước ngày hết hạn'
            ),
            type: 'error'
          })
          return
        }
      }

      const params = {
        clinic_id: self.$globalClinic.id,
        national_id: self.form.national_id,
        cmnd: self.form.cmnd,
        phone: self.form.phone,
        gender: self.form.gender || 2,
        career: self.form.career,
        foreigner: self.form.foreigner,
        address: self.form.address,
        address_district_name: self.form.address_district_name,
        address_province_name: self.form.address_province_name,
        address_wards_name: self.form.address_wards_name,
        work_at: self.form.work_at,
        insurance_type: self.form.insurance_type,
        insurance_start_date: self.form.insurance_start_date,
        emergency_contact: self.form.emergency_contact,
        contact_phone: self.form.contact_phone,
        insurance_rate: Number(self.form.insurance_rate),
        pid: self.form.pid || Date.now().toString(),
        name: self.form.name?.toUpperCase(),
        birthday: self.form.birthday,
        ethnic_name: self.form.ethnic_name,
        insurance_number: self.form.insurance_number,
        insurance_expire: self.form.insurance_expire,
        nationality_name: self.form.nationality_name,
        admission_hospital_date: this.formatDate(
          self.form.admission_hospital_date
        ),
        insurances: self.form.insurances?.map(item => ({
          ...item,
          start_date: window
            .moment(item.start_date)
            .startOf('days')
            .valueOf(),
          end_date: window
            .moment(item.end_date)
            .endOf('days')
            .valueOf()
        }))
      }

      if (this.isConfirm) {
        this.createPatient(params)
      } else if (this.form.id) {
        this.$confirm(
          this.$t(
            'lbl_the_patient_s_old_data_will_be_updated__do_you_want_to_update'
          ),
          this.$t('lbl_warning'),
          {
            cancelButtonText: this.$t('lbl_cancel'),
            confirmButtonText: this.$t('lbl_save')
          }
        )
          .then(_ => {
            this.updatePerson(params)
          })
          .catch(_ => { })
      } else {
        this.postPerson(params)
      }
    },
    async updatePerson (params) {
      const self = this

      self.isLoading = true
      await self.$rf
        .getRequest('DoctorRequest')
        .updatePatientV2(this.form.id, params)

        .then(resp => {
          if (resp) {
            self.$emit('refresh', resp.data)
            self.$message({
              message: this.$t('lbl_update_success'),
              type: 'success'
            })
            self.handleClose()
          }
        })
        .catch(e => {
          console.log(e)
          self.isLoading = false
        })
        .finally(() => {
          self.isLoading = false
        })
    },
    async postPerson (params) {
      const self = this

      self.isLoading = true
      await self.$rf
        .getRequest('DoctorRequest')
        .createPersonV2({
          ...params,
          is_create_emr: this.hasMammo || this.hasAnapath || false
        })

        .then(resp => {
          if (resp) {
            self.$emit('refresh', resp.data)
            self.$message({
              message: this.$t('lbl_add_success'),
              type: 'success'
            })
            self.handleClose()
          }
        })
        .catch(e => {
          console.log(e)
          self.$message({
            message: e,
            type: 'error'
          })
          self.isLoading = false
        })
        .finally(() => {
          self.isLoading = false
        })
    },

    handleClose () {
      this.isRequestSamePerson = true
      this.dialogVisible = false
      this.form = { ...this.defaultForm }
      this.arrExist = [...this.DEFAULT_EXIST]
      this.selectedAddress = {}
      this.openDialog(false)
    },
    async getAddressVietnam (params) {
      try {
        const response = await this.$rf
          .getRequest('DoctorRequest')
          .getAddressVietnam(params)
        return response.data
      } catch (error) {
        console.log(error)
      }
    },
    async handleGetProvinces () {
      const params = {
        type: ADDRESS_TYPE.province
      }
      const data = (await this.getAddressVietnam(params)) || []
      this.provinces = data?.map(item => ({
        ...item,
        name: item?.name?.trim()
      }))
    },
    async handleGetDistricts () {
      const params = {
        type: ADDRESS_TYPE.district,
        pro_code: this.selectedAddress?.province?.province_id
      }
      const data = await this.getAddressVietnam(params)
      this.districts = data || []
    },
    async handleGetWards () {
      const params = {
        type: ADDRESS_TYPE.ward,
        district_code: this.selectedAddress?.district?.district_id
      }
      const data = await this.getAddressVietnam(params)
      this.wards = data || []
    },
    handleSelectProvince (province) {
      const provinceInfo = this.provinces.find(item => item?.name === province)
      this.selectedAddress.province = provinceInfo
      delete this.selectedAddress.district
      delete this.selectedAddress.ward
      this.form.address_district_name = ''
      this.form.address_wards_name = ''
    },
    handleSelectDistrict (district) {
      const districtInfo = this.districts.find(item => item?.name === district)
      this.selectedAddress.district = districtInfo
      delete this.selectedAddress.ward
      this.form.address_wards_name = ''
    },
    async createPatient (params) {
      // Used when sync his
      try {
        // if (this.form.doc_no) {
        //   params.doc_no = String(this.form.doc_no)
        // }

        const dataHisPerson = {
          ...this.patientInfo,
          insurance_rate: Number(this.patientInfo.insurance_rate),
          name: this.patientInfo.name?.toUpperCase(),
          insurance_expire: this.patientInfo.insurance_expire,
          admission_hospital_date: this.formatDate(
            this.patientInfo.admission_hospital_date
          )
        }

        console.log(this.patientInfo.admission_hospital_date)

        const response = await this.$rf
          .getRequest('DoctorRequest')
          .createPersonV2({
            ...params,
            data_his_person: dataHisPerson,
            source_type: 2,
            is_create_emr: this.hasMammo || this.hasAnapath || false
          })
        this.$toast.open({
          message: this.$t(
            'lbl_successful_patient_archiving_you_can_continue_with_the_medical_record_creation_process_'
          ),
          type: 'success'
        })
        const responseData = response.data || {}
        this.$emit('refresh', {
          ...responseData,
          is_sync: this.patientInfo.is_sync
        })
        this.handleClose(true)
      } catch (error) {
        console.log(error)
        if (error?.response?.data?.code === 500001) {
          this.$toast.open({
            message: this.$t(
              'lbl_patient_code__pid__already_exists_in_the_system_please_enter_a_new_code_to_create_a_patient'
            ),
            type: 'error'
          })
        } else {
          this.$toast.open({
            message: this.$t('lbl_an_error_occurred_while_storing_the_patient'),
            type: 'error'
          })
        }
      }
    },
    handleCancel () {
      if (this.isConfirm) {
        this.$emit('refresh', this.form)
      }
      this.handleClose()
    },
    formatDate (date) {
      if (!date) return ''
      console.log(date)
      return window.moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    handleAddInsurance () {
      this.form.insurances.push({
        name: '',
        policy_number: '',
        start_date: null,
        end_date: null
      })
      setTimeout(() => this.handleScroll(), 100)
    },
    handleRemoveVideo (index) {
      this.form.insurances.splice(index, 1)
    },
    handleScroll () {
      const insurancesEl = document.getElementById('InsuranceList')
      // insurancesEl.scrollTop = insurancesEl.scrollHeight
      insurancesEl.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'end'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .cs-modal {
    background-color: #f9fafb;
    overflow: hidden;
    height: 100vh;

    .el-dialog__header {
      background-color: white;
      padding-bottom: 0;
    }

    .el-dialog__body {
      padding: 40px;
      padding-right: 20px;
      padding-left: 66px;
    }
  }

  .hodo-el {
    .el-input__inner {
      background: white !important;
      border: 1px solid #dee2e6 !important;
      border-radius: 10px !important;
      width: 100%;
    }
  }

  .cs-radio {
    .el-radio__inner {
      width: 20px;
      height: 20px;
    }
  }

  .el-select {
    width: 100%;
  }

  .cs-uppercase {
    .el-input__inner {
      text-transform: uppercase;
    }
  }

  .cs-content {
    height: calc(100vh - 250px);

    &::-webkit-scrollbar {
      display: none;
    }
  }
}

.cs-button-delete {
  padding: 4px;
  margin: 0 4px;
  border: 1px solid #ea5455;
  border-radius: 4px;
  cursor: pointer;
  width: fit-content;

  &:hover {
    outline: #eb9a9a solid 1px;
    box-shadow: -2px -19px 150px 3px #f1b9b9;
    -webkit-box-shadow: -2px -19px 150px 3px #f1b9b9;
    -moz-box-shadow: -2px -19px 150px 3px #f1b9b9;
  }
}

.cs-button-add {
  padding: 4px;
  margin: 0 4px;
  border: 1px solid #345fd3;
  border-radius: 4px;
  cursor: pointer;
  width: fit-content;

  &:hover {
    outline: #345fd3 solid 1px;
    box-shadow: -2px -19px 150px 3px #345fd3;
    -webkit-box-shadow: -2px -19px 150px 3px #345fd3;
    -moz-box-shadow: -2px -19px 150px 3px #345fd3;
  }
}
</style>
